module.exports = __webpack_public_path__ + "img/icon-customer-service@2x.38c0e2a5.png";